<template>
  <div :class="`wrap ${wrapClass}`">
    <router-view class="router-view" v-slot="{ Component }">
      <transition :name="transitionName">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import { getLocal, getRole, getRoleId, setLocal, getCookie } from "@/common/js";
import * as echarts from "echarts";
import { provide } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      transitionName: "slide-left",
      wrapClass: "",
    });
    provide("ec", echarts); //provide
    //在页面加载时读取sessionStorage里的状态信息
    if (getLocal("dsj_accessToken") && getLocal("dsj_store")) {
      store.replaceState(
        Object.assign({}, store.state, JSON.parse(getLocal("dsj_store")))
      );
    }
    console.log('store.state -->', store.state)

    window.addEventListener("beforeunload", () => {
      if (getLocal("dsj_accessToken")) {
        setLocal("dsj_store", JSON.stringify(store.state));
      }
    });

    const whiteList = ["/login", "/forgetPassword", "/test", "/error"];
    let isAdmin = false;
    router.beforeEach(async (to, from, next) => {
      let accessToken = getLocal("dsj_accessToken");
      let roleId = await getRoleId();
      const {
        query: { isadmin = 0 },
      } = to;
      if (isadmin == 1) {
        isAdmin = true;
        //  || getCookie("accessToken")
        // console.log('accessToken===', accessToken)
        /** 为了兼容后台管理 展示审核详情 start */
        if (!accessToken) {
          accessToken = getCookie("accessToken");
          setLocal("dsj_accessToken", accessToken);
        }
        if (roleId == 0) {
          roleId = getCookie("role_id");
          setLocal("dsj_roleId", roleId);
        }
        next();
        return false;
        /** 为了兼容后台管理 展示审核详情  end */
      }
      const modifyPwd = getLocal("dsj_modifyPwd");
      const role = await getRole();

      // iframe页面需要添加高度
      const iframeCssWhiteList = [
        "/organization/infoStatistics",
        "/info/detail",
        "/info/add",
        "/updatePasswrod",
      ];
      // iframe页面需要添加高度
      if (iframeCssWhiteList.indexOf(to.path) !== -1) {
        state.wrapClass = "wrap1";
      } else {
        state.wrapClass = "";
      }
      /**
       *
       *  1. 判断是否登陆过
       *   是：
       *    1.1 判断是否修改过密码
       *    1.2 判断角色 进入对应页码
       *    1.3 兼容后台管理进入审核详情页面
       *   否： 跳转登录页面
       */

      // 判断是否登录
      if (accessToken) {
        // 判断是否是修改过密码,
        if (modifyPwd === "true" && to.path !== "/updatePasswrod") {
          next({ path: "/updatePasswrod" });
        } else {
          // 判断大队辅导员以外的角色不可以进入组织管理相关页面
          if (!role && to.path.indexOf("/organization/") !== -1) {
            next({ path: "/error" });
          } else {
            /** 为了兼容后台管理 展示审核详情 后台管理直接跳转  */
            if (isAdmin) {
              next();
            } else {
              /** 移动端跳转 */
              if (
                roleId < 3 &&
                to.path !== "/organization/management" &&
                from.path == "/"
              ) {
                next({ path: "/organization/management" });
              } else {
                // // 判断是否填写过表单基础信息 进入首页区分跳转页面
                // if (profileExists && from.path == "/") {
                //   // 大队辅导员填写过
                //   if (roleId < 5) {
                //     next({ path: "/info/detail/counsellor" });
                //   } else {
                //     // 总辅填写过
                //     next({ path: "/info/detail/zf" });
                //   }
                // } else {
                next();
                // }
              }
            }
          }
        }
      } else {
        // 未登录
        if (whiteList.indexOf(to.path) !== -1) {
          next();
        } else {
          next({ path: `/login?redirect=${to.path}` });
        }
      }
    });
    return {
      ...toRefs(state),
    };
  },
};
</script>

<style>
#app {
  /* font: 0.32rem/1.74 "microsoft yahei", "simsun", \5b8b\4f53, arial; */
  color: #333;
  /* background: #f9f9f9; */
  height: 100%;
}
</style>
